let _interfaces: any = null;

const useInterface = (interfaceName: string) => {
  if (!_interfaces[interfaceName]) {
    console.error(`Interface "${interfaceName}" does not exist, or you don't have access to it.`);
    return {};
  }

  return _interfaces[interfaceName];
};

export const setInterfaces = (interfaces: any) => {
  if (typeof interfaces !== "object" || Array.isArray(interfaces)) throw new Error("Interfaces must be an object");

  _interfaces = interfaces;
};

export default useInterface;
